module.exports = __webpack_public_path__ + "static/media/postgres_sql_logo.bf2df4af.png";